import { container } from "@/inversify.config";
import { CatalogOperationVue } from "fs-pb-vue2/vueModels/operations/CatalogOperationVue";
import { OperationPropertyModel } from "fs-pb-vue2/models/operations/operationPropertyModel";
import { Dictionary } from "fs-pb-vue2/data/types";
import { CatalogOperationModel } from "fs-pb-vue2/models/operations/catalogOperationModel";
import { Watch } from "vue-property-decorator";
import i18n from "@/i18n";

/**Модель представления операции */
export class CatalogOperationVueFS extends CatalogOperationVue {
  @Watch("redirectUrl")
  onRedirectUrlChange(value: string) {
    if (value) {
      setTimeout(() => {
        window.location.href = value;
      }, 3000);
    }
  }

  @Watch("this.personStore.personInfo.Data.EnableSbpIn", { immediate: true })
  onSbpInEnabledChanged(value: boolean): void {
    this.OperationModel.EnableSbpIn = value;
  }

  @Watch("this.personStore.personInfo.Data.EnableSbpOut", { immediate: true })
  onSbpOutEnabledChanged(value: boolean): void {
    this.OperationModel.EnableSbpOut = value;
  }

  get sbpOutVisible(): boolean {
    return !this.personStore.personInfo.Data.EnableSbpOut;
  }

  get redirectUrl(): string {
    if (!this.successDetails?.RequestData?.keys || !this.successDetails?.RequestData?.values) {
      return '';
    }

    const index = this.successDetails.RequestData.keys.indexOf('redirectUrl');

    return index !== -1 
      ? this.successDetails.RequestData.values[index]
      : '';
  }

	initDefaultContractToValue(): void {
    const contractItem: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name === 'contract');
    if (this.$route.name === 'Operation' && this.operInitType == 0 && contractItem && contractItem.Value.Key !== this.personStore.personInfo.Data.DefaultInAccount) {
      const contractToItem: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name === 'contractTo');
      if (contractToItem && this.personStore.personInfo.Data.DefaultInAccount && !this.$route.query.contractTo) {
        contractToItem.Value = contractToItem.Values.find((val: any) => val.Key === this.personStore.personInfo.Data.DefaultInAccount);
      }
			if (contractItem && this.personStore.personInfo.Data.DefaultInAccount && this.operId.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation) {
        contractItem.Value = contractItem.Values.find((val: any) => val.Key === this.personStore.personInfo.Data.DefaultInAccount);
			}
    }
  }

	/**Метод для выполнения после успешного проведения */
	async afterExecute(): Promise<void> {
    this.appStore.setLoading(true);

    this.successDetails = await this.detailsService.getOperationDetails({ Id: this.OperationModel.OperationId, ReferenceId: "" });
    localStorage.setItem('continueUrl', '');
    this.personStore.personInfo.Data.EnableSbpIn = this.OperationModel.EnableSbpIn;
    this.personStore.personInfo.Data.EnableSbpOut = this.OperationModel.EnableSbpOut;
    this.appStore.setLoading(false);
	}

  async next(): Promise<void> {
    if (this.isInit && this.printForSbp && !this.OperationModel.EnableSbpOut) {
      this.alertService.error(i18n.t('main.operations.errors.sbpOutEnable').toString());
      return;
    }
    await super.next();
  }

	async initOperation(): Promise<void> {
    this.loading = true;
    let addInitData: Dictionary<string | string[]> = {};
    if (this.$route.query.initDataId) {
      const localData: Array<string> = window.localStorage.getItem(this.$route.query.initDataId.toString()).split('&');
      for (const i in localData) {
        addInitData[localData[i].substring(0, localData[i].indexOf('='))] = localData[i].substring(localData[i].indexOf('=')+1);
      }
    } else {
      for (const i in this.$route.query) {
        addInitData[i] = this.$route.query[i];
      }
    }
    if (Object.keys(addInitData).length === 0 && !!this.addInitData)
      addInitData = this.addInitData;

    this.OperationModel = (await this.service.init(
      this.operId,
      this.operInitType,
      addInitData
    )) as CatalogOperationModel;

    this.OperationModel.EnableSbpIn = this.personStore.personInfo.Data.EnableSbpIn;
    this.OperationModel.EnableSbpOut = this.personStore.personInfo.Data.EnableSbpOut;

    this.initDefaultContractToValue();

    this.loading = false;
  }
}